import { Constants } from '../theme'

export const supportWhatsAppUrl = (message) =>
  `https://api.whatsapp.com/send?phone=${Constants.SUPPORT_WHATSAPP}&text=${encodeURIComponent(message)}`
